var render = function render(_c,_vm){return _c('div',{staticClass:"flex justify-end flex-grow-0 px-4 py-4 border-t border-gray-200 sm:px-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }